import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ValidatorErrorHandlerService } from '@core/services';
import { environment } from '@environments/environment';
import { CustomErrors } from '@shared/models';
import { UserContextService } from '@shared/services';
import { BehaviorSubject, map, Observable, switchMap } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class TreeProductMediaService {
	private _portalUrl: string;
	public selectedCustomerId$ = new BehaviorSubject<number>(0);

	constructor(
		private http: HttpClient,
		private validatorErrorHandlerService: ValidatorErrorHandlerService,
		private _userContextService: UserContextService,
	) {
		this._portalUrl = environment.portalBaseAddress;
		this._userContextService
			.getVendor()
			.pipe(map(_ => _.id))
			.subscribe(_ => this.selectedCustomerId$.next(_));
	}

	public getProductMedia(productId: number): Observable<ITreeProductMediaModel | undefined> {
		return this.selectedCustomerId$.pipe(
			switchMap(customerId => {
				const url = `${this._portalUrl}/api/v2/media/customers/${customerId}/products/${productId}/images`;
				return this.http
					.get<ITreeProductMediaModel>(url)
					.pipe(
						this.validatorErrorHandlerService.suppressErrors([CustomErrors.ProductMediaNotFound]),
						this.validatorErrorHandlerService.catchError(),
					);
			}),
		);
	}

	public getVariantMedia(productId: number, variantId: number): Observable<ITreeProductMediaModel | undefined> {
		return this.selectedCustomerId$.pipe(
			switchMap(customerId => {
				const url = `${this._portalUrl}/api/v2/media/customers/${customerId}/products/${productId}/variants/${variantId}/images`;
				return this.http
					.get<ITreeProductMediaModel>(url)
					.pipe(
						this.validatorErrorHandlerService.suppressErrors([CustomErrors.ProductMediaNotFound]),
						this.validatorErrorHandlerService.catchError(),
					);
			}),
		);
	}

	public GetVariantDefaultThumbnailUrl(productId: number, variantId: number): string {
		const url = `${this._portalUrl}/api/v2/media/customers/${this.selectedCustomerId$.value}/products/${productId}/variants/${variantId}/images/default/thumbnail`;
		return url;
	}

	public GetVariantDefaultImageUrl(productId: number, variantId: number): string {
		const url = `${this._portalUrl}/api/v2/media/customers/${this.selectedCustomerId$.value}/products/${productId}/variants/${variantId}/images/default`;
		return url;
	}

	public GetProductDefaultImageUrl(productId: number) {
		const url = `${this._portalUrl}/api/v2/media/customers/${this.selectedCustomerId$.value}/products/${productId}/images/default`;
		return url;
	}
}

export interface ITreeProductMediaModel {
	productId: number;
	media: ITreeProductMediaItemModel[];
}

export interface ITreeProductMediaItemModel {
	originUrl: string;
	thumbnailUrl: string;
}
